module.exports = __webpack_public_path__ + "img/badge_bg.47ceaadf.png";